<template>
    <div
        class="passwordFind mainContainer bgGray"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="passwordFind-banner">
            <img src="~assets/images/password/bannerImg.png" alt="" />
        </div>
        <div class="w11 passwordContent">
            <h3>重置密码</h3>
            <div class="password-steps">
                <el-steps :active="active" align-center>
                    <el-step title="输入用户名"></el-step>
                    <el-step title="身份验证"></el-step>
                    <el-step title="设置新密码"></el-step>
                    <el-step title="完成"></el-step>
                </el-steps>
            </div>
            <!-- 第一步：输入用户名 -->
            <div class="password-find-one w300 mtop30" v-if="active == 1">
                <el-form
                    ref="pFormOne"
                    :model="pFormOne"
                    :rules="pFormOneRules"
                    key="1"
                >
                    <el-form-item prop="username">
                        <el-input
                            placeholder="请输入用户名"
                            :disabled="disabledOne"
                            v-model="pFormOne.username"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            class="w300"
                            type="primary"
                            @click.native.prevent="checkUserName('pFormOne')"
                            :disabled="disabledOne"
                            >下一步</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
            <!-- 第二步：输入身份证号 -->
            <div class="password-find-two w300 mtop30" v-if="active == 2">
                <el-form
                    ref="pFormTwo"
                    :model="pFormTwo"
                    :rules="pFormTwoRules"
                    key="2"
                >
                    <el-form-item prop="idNumber">
                        <el-input
                            placeholder="请输入姓名"
                            :disabled="disabledTwo"
                            v-model="pFormTwo.idNumber"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="veriCode">
                        <el-input placeholder="请输入短信验证码" v-model="pFormTwo.veriCode">
                            <span slot="append" style="cursor: pointer;" @click="sendSmsCode" v-if="!countDown">{{
                                countDown > 0 ? `${countDown}秒后重新发送` : '发送短信验证码' }}</span>
                            <span slot="append" style="cursor: not-allowed; color: #999;" v-else>{{ countDown
                            }}秒后重新发送</span>
                        </el-input>
                    </el-form-item>
                    <span style="color:red;font-size: 12px;">{{ msg }}</span>
                    <el-form-item>
                        <el-button
                            class="w300"
                            type="primary"
                            @click.native.prevent="checkIdNumber('pFormTwo')"
                            :disabled="disabledTwo"
                            >下一步</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
            <!-- 第三步：输入、确认新密码 -->
            <div class="password-find-two w500 mtop30" v-if="active == 3">
                <el-form
                    ref="pFormThree"
                    :model="pFormThree"
                    label-width="102px"
                    label-position="left"
                    :rules="pFormThreeRules"
                    status-icon
                    size="medium"
                    key="3"
                >
                    <el-form-item label="新密码：" prop="password">
                        <el-input
                            v-model="pFormThree.password"
                            type="password"
                            :disabled="disabledThree"
                            placeholder="请输入密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="comfirePass">
                        <el-input
                            v-model="pFormThree.comfirePass"
                            type="password"
                            :disabled="disabledThree"
                            placeholder="请输入重复密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            class="w300"
                            type="primary"
                            style="margin: 0 auto; display: block"
                            @click.native.prevent="subPassword('pFormThree')"
                            :disabled="disabledThree"
                            >重置密码</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
            <!-- 第四步：成功重置密码提示 -->
            <div class="password-find-two w300 mtop30" v-if="active == 4">
                <el-result
                    icon="success"
                    title="重置密码成功"
                >
                    <template slot="extra">
                        <el-button type="primary" size="medium" @click="enterLogin">去登陆</el-button>
                    </template>
                </el-result>
            </div>
        </div>
    </div>
</template>
<script>
import { isIdentityId, isvalidPass } from "@/utils/validate.js";
import { resetPassword } from "api/personal";
import { sendVeriCode } from "@/api/smsCode"
export default {
    data() {
        var checkIdentitytionId = (rule, value, callback) => {
            console.log(value);
            var errorMsg = isIdentityId(value);
            if (errorMsg != "") {
                callback(new Error(errorMsg));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else if (!isvalidPass(value)) {
                callback(
                    new Error(
                        "密码以字母开头 长度在6~12之间 只能包含字母、数字和下划线"
                    )
                );
            } else {
                if (this.pFormThree.repassword !== "") {
                    this.$refs.pFormThree.validateField("comfirePass");
                }
                callback();
            }
        };

        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入确认密码"));
            } else if (value !== this.pFormThree.password) {
                callback(new Error("两次输入密码不一致！"));
            } else {
                callback();
            }
        };

        return {
            loading: false,
            loadingText: "",
            active: 1,
            pFormOne: {
                username: "",
            },
            pFormOneRules: {
                username: [
                    {
                        required: true,
                        validator: checkIdentitytionId,
                        trigget: "blur",
                    },
                ],
            },
            disabledOne: false,
            pFormTwo: {
                idNumber: "",
                veriCode: "", // 短信验证码
            },
            pFormTwoRules: {
                idNumber: [
                    {
                        required: true,
                        message:"请输入姓名",
                        trigger: "blur",
                    },
                ],
                veriCode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "blur"
                    },
                    {
                        len: 6,
                        message: "验证码长度为6位",
                        trigger: "blur"
                    }
                ]
            },
            disabledTwo: false,
            pFormThree: {
                password: "",
                comfirePass: "",
            },
            pFormThreeRules: {
                password: [
                    {
                        required: true,
                        validator: validatePass,
                        trigget: "blur",
                    },
                ],
                comfirePass: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigget: "blur",
                    },
                ],
            },
            disabledThree: false,
            countDown:0,
            msg:'',
        };
    },
    methods: {
        // 发送短信验证码
        async sendSmsCode() {
            // 如果正在倒计时，不执行操作
            if (this.countDown > 0) {
                return;
            }

            // 立即开始倒计时
            this.countDown = 60; // 假设倒计时60秒，可根据需求调整
            this.timer = setInterval(() => {
                this.countDown--;
                if (this.countDown <= 0) {
                    clearInterval(this.timer);
                    this.countDown = 0;
                }
            }, 1000);

            try {
                const { errorCode, msg } = await sendVeriCode({
                    username: this.pFormOne.username,
                    smsType: 'reset_bus_sms',
                    phoneNumber: this.pFormOne.username
                });

                if (errorCode === '2000') {
                    this.$message.success("验证码发送成功");
                    this.msg = msg;
                } else {
                    // 发送失败，清除计时器并重置倒计时
                    clearInterval(this.timer);
                    this.countDown = 0;
                    this.$message.error(msg || "验证码发送失败");
                }
            } catch (error) {
                // 捕获请求异常，同样清除计时器
                clearInterval(this.timer);
                this.countDown = 0;
                console.error("发送验证码失败:", error);
            }
        },
        enterLogin(){
            this.$router.push("/pcViews/login");
        },
        subPassword(formName) {
            this.disabledThree = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.loadingText = "密码重置中...";
                    resetPassword(
                        this.pFormOne.username,
                        this.pFormTwo.veriCode,
                        this.pFormTwo.idNumber,
                        this.pFormThree.password
                    ).then((res) => {
                        const { success } = res;
                        if (success) {
                            this.active = 4;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                        this.loading = false;
                        this.loadingText = "";
                        this.disabledThree = false;
                    });
                } else {
                    this.disabledThree = false;
                }
            });
        },
        checkIdNumber(formName) {
            this.disabledTwo = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.loadingText = "校验用身份正号中...";
                    resetPassword(
                        this.pFormOne.username,
                        this.pFormTwo.veriCode,
                        this.pFormTwo.idNumber
                    ).then((res) => {
                        const { success } = res;
                        if (success) {
                            this.active = 3;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                        this.loading = false;
                        this.loadingText = "";
                        this.disabledTwo = false;
                    });
                } else {
                    this.disabledTwo = false;
                }
            });
        },
        checkUserName(formName) {
            this.disabledOne = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.loadingText = "校验用户名中...";
                    resetPassword(this.pFormOne.username).then((res) => {
                        const { success } = res;
                        if (success) {
                            this.active = 2;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                        this.loading = false;
                        this.loadingText = "";
                        this.disabledOne = false;
                    });
                } else {
                    this.disabledOne = false;
                }
            });
        },
    },
};
</script>
<style>
.password-steps .el-step__title.is-process {
    font-weight: normal;
}
.password-steps .el-step__description.is-finish {
    color: #b21f27;
}
.password-steps .el-step__title.is-finish {
    color: #b21f27;
}
.password-steps .el-step__head.is-finish {
    color: #b21f27;
    border-color: #b21f27;
}
.password-steps .el-steps {
    width: 100%;
}
</style>
<style lang="less" scoped>
.w500 {
    width: 500px;
}
.w300 {
    width: 300px;
}
.password-steps {
    margin: 30px 0;
    width: 100%;
    height: 60px;
}
.passwordContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    position: absolute;
    top: 80px;
    left: 50%;
    margin-left: -550px;
    background: #fff;
    box-shadow: 0px 0px 9px 0px rgba(40, 40, 40, 0.2);
    > h3 {
        margin-bottom: 20px;
        height: 30px;
        line-height: 30px;
        font-size: 20px;
        color: #505050;
    }
}
.passwordFind-banner {
    height: 110px;
    > img {
        width: 100%;
    }
}
.passwordFind {
    position: relative;
}
</style>
